// extracted by mini-css-extract-plugin
module.exports = {"donationSuccess":"DonationSuccess_donationSuccess__13MU3","backdrop":"DonationSuccess_backdrop__3Sjd-"};